export const GTextGradient = ({ text }: { text: string }) => {
  return <span className="text-transparent uppercase bg-gradient-to-r from-primary to-amber-500 bg-clip-text">{text}</span>;
};
